import { useState } from 'react';
import { Typography } from '@mui/material';
import Column from '../Column';
import ExpandButton from '../Button/ExpandButton';
import Row from '../Row';

interface CollapsibleTextProps {
    text: string;
    maxChars?: number;
}

export default function CollapsibleText({ text, maxChars = 200 }: CollapsibleTextProps) {
    const [expanded, setExpanded] = useState(false);
    const isOverflowing = text.length > maxChars;

    const toggleExpanded = () => setExpanded((prev) => !prev);

    if (!isOverflowing) {
        return <Typography>{text}</Typography>;
    }

    const previewText = text.substring(0, maxChars).trim();

    return (
        <Column gap={1}>
            <Typography>{expanded ? text : `${previewText}...`}</Typography>
            <Row justifyContent="center">
                <ExpandButton size="small" expand={expanded} onClick={toggleExpanded}>
                    {expanded ? 'Read Less' : 'Read More'}
                </ExpandButton>
            </Row>
        </Column>
    );
}
